import Vue from 'vue'
import { Getter, Action, Mutation } from 'vuex-class'
import { Component, Watch } from 'vue-property-decorator'
import Footer from '@/components/footer/footer'
import SkeletonFluid from '@/components/skeletonFluid/skeletonFluid'
import Header from '@/components/header/header'
import AsideCart from '@/components/asideCart/asideCart'
import ProductsBtn from '@/components/productsBtn/productsBtn'

@Component({
  components: {
    Header,
    AsideCart,
    Footer,
    ProductCarousel: () => import('@/components/productCarousel/productCarousel'),
    ButtonNumber: () => import('@/components/buttonNumber/buttonNumber'),
    AddCartButton: () => import('@/components/addCartButtom/addCartButtom'),
    modalCar: () => import('@/components/modalCar/modalCar'),
    SkeletonBanner: () => import('@/components/skeletonBanner/skeletonBanner'),
    ModalAddons: () => import('@/components/modalAddons/modalAddons'),
    SkeletonFluid,
    ProductsBtn
  }
})
export default class Product extends Vue {
  @Action action_getCurrentProduct
  @Getter getCurrentProduct
  @Getter getCountry
  @Getter getCity
  @Getter getCartTemporal
  @Mutation IS_SELECT_COUNTRY;

  isShowCar = false
  isOpenAddons = false
  isEditAddons = false

  isBtnLoaded = false
  isProductLoaded = false

  async mounted() {
    this.IS_SELECT_COUNTRY(true)
    const id = this.$route.params.id
    await this.action_getCurrentProduct({
      idc: this.getCity.id,
      idp : id
    })
    this.isProductLoaded = true;
  }

  @Watch('isBtnLoaded')
  onIsBtnLoaded() {
    this._executeAddBtn();
  }
  @Watch('isProductLoaded')
  onProductLoaded() {
    this._executeAddBtn();
  }

  get geActiveProdcut() {
    const cart = this.getCartTemporal
    const product = (this.getCurrentProduct as any)
    const index = cart.findIndex((item) => item.product.id === product.id)
    return index !== -1 && product.product_options && product.product_options.length
  }

  get getPrice() {
    const cart = this.getCartTemporal
    const product = (this.getCurrentProduct as any)
    const index = cart.findIndex((item) => item.product.id === product.id)
    const productFilter = cart.filter((item) => item.product.id === product.id)
    // capturamos el precio del producto
    let price = parseFloat(product.price)
    if (index !== -1) {
      // revisamos si el usuario tiene adicionales seleccionado
      if (productFilter.length && productFilter[0].hasOwnProperty('addons')) {
        productFilter[0].addons.map((item) => {
          // validamos si el grupo modificador es multiseleccion o seleccion unica
          // luego sumamos cada addon con el precio del producto
          if (item.is_multiple) {
            item.addons.map((a) => {
              let priceAddon = parseFloat(a.price)
              price = price + priceAddon
            })
          } else {
            let priceAddon = parseFloat(item.addons.price)
            price = price + priceAddon
          }
        })
      }
    }

    return this.$currency.format(price, { code: this.getCountry.currency })
  }

  get gerBanners() {
    let banners = this.getCurrentProduct && Object.keys(this.getCurrentProduct).length && this.getCurrentProduct.product_banners
    banners.sort((a, b) => a.ordinal - b.ordinal)
    return banners
  }

  _toggleCard(edit = false) {
    this.isShowCar = !this.isShowCar
  }

  _addToCartReturn() {
    if (window.history.length <= 2) {
      this.$router.push({ name: 'city', params: { city_id: this.getCurrentProduct.commerce_id }, query: { modalOpen: 'true' } })
    } else {
      this.$router.push({ name: 'city', params: { city_id: this.getCurrentProduct.commerce_id } })
    }
  }

  _toggleBtn() {
  }

  _onAddons(edit = false) {
    if (edit) this.isEditAddons = true
    this.isOpenAddons = !this.isOpenAddons
  }

  _onCloseAddons() {
    this.isEditAddons = false
    this.isOpenAddons = false
  }

  onButtonNumberMounted() {
    this.isBtnLoaded = true
  }

  _executeAddBtn() {
    if (this.isBtnLoaded && this.isProductLoaded) {
      const productCart = this.getCartTemporal.find((item) => item.product.id === this.getCurrentProduct.id)
      if (!productCart) {
        this.$nextTick(() => {
          (this.$refs.buttonNumber as any)._add(this.getCurrentProduct)
        })
      }
    }
  }

}
